export default __webpack_public_path__ + "static/media/emojiSheet.2896791f.png";